import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Box, Button, ButtonBase, Stack } from '@mui/material';
import { CardsSVG, CollectionsSVG, SummarySVG } from '../../components';
import { useTranslation } from 'react-i18next';
import { CalendarIcon } from '@mui/x-date-pickers';
import { VectorMenuSVG } from '../../components/svg/VectorMenuSVG';
import EXPIRATIONS_CLOSING_GROUPS from '../../constants/expirationgroups/groups';
import { palette } from '../../styles/theme';
import { ROUTES } from '../../constants/routes/routes';

const groupStyles = (isActive) => (isActive ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button');

export default function ProductsDropMenu () {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const cardsRoute = ROUTES.PRODUCTS.CARDS.BASE;
    const collectionsRoute = ROUTES.PRODUCTS.CARDS.COLLECTIONS;
    const summariesRoute = ROUTES.PRODUCTS.CARDS.SUMMARIES;
    const expirationsRoute = ROUTES.PRODUCTS.CARDS.EXPIRATIONS;
    const isExpirationsRoute = location.pathname.startsWith(expirationsRoute);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState('');
    const [selectedTab, setSelectedTab] = useState();
    const { id } = useParams();

    const handleSelectTab = (group) => {
        setSelectedTab(group);
        history.push(`${expirationsRoute}/${group}`);
    };

    const handleRoute = (path) => {
        history.push(path);
    };

    const triggerExpirationsDropDownMenu = () => {
        setIsSubMenuOpen(!isSubMenuOpen);
        if (!isSubMenuOpen && !selectedTab) handleSelectTab(53);
    };

    useEffect(() => {
        if (!isExpirationsRoute) return;
        setIsSubMenuOpen(true);
        setSelectedTab(EXPIRATIONS_CLOSING_GROUPS[id]);
    }, [isExpirationsRoute, id]);

    return (
        <Box>
            <Stack className='clientDropMenu_menu--box' gap={'16px'}>
                <Button
                    className={location.pathname === cardsRoute ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                    onClick={() => { handleRoute(cardsRoute); }}
                >
                    <Stack direction='row' gap={'8px'} alignItems='center' justifySelf={'flex-start'}>
                        {location.pathname === cardsRoute ? <CardsSVG customStroke='white'/> : <CardsSVG/>}
                        <span className={location.pathname === cardsRoute ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('cards.title')}</span>
                    </Stack>
                </Button>
                {
                    <Button
                        className={location.pathname === summariesRoute ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                        onClick={() => { handleRoute(summariesRoute); }}
                    >
                        <Stack direction='row' gap={'8px'} alignItems='center' justifySelf={'flex-start'}>
                            {location.pathname === summariesRoute ? <SummarySVG customStroke='white'/> : <SummarySVG/>}
                            <span className={location.pathname === summariesRoute ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('summary.title')}</span>
                        </Stack>
                    </Button>
                }

                <Button
                    className={location.pathname === collectionsRoute ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                    onClick={() => { handleRoute(collectionsRoute); }}
                >
                    <Stack direction='row' gap={'8px'} alignItems='center' justifySelf={'flex-start'}>
                        {location.pathname === collectionsRoute ? <CollectionsSVG customStroke='white'/> : <CollectionsSVG/>}
                        <span className={location.pathname === collectionsRoute ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('collections.title')}</span>
                    </Stack>
                </Button>

                <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center', flex: 1 }} className={isSubMenuOpen ? 'clientSubMenu_active--button' : 'clientSubMenu_inactive--button'}
                >
                    <ButtonBase
                        onClick={triggerExpirationsDropDownMenu}
                    >
                        <Stack direction='row' gap={'8px'} alignItems='center' justifySelf={'flex-start'}>
                            {isSubMenuOpen ? <CalendarIcon sx={{ color: 'white !important', width: '24px', height: '24px' }} /> : <CalendarIcon sx={{ color: `${palette.icons} !important`, width: '24px', height: '24px' }} />}
                            <span className={isSubMenuOpen ? 'button_subMenuActive-text' : 'button_subMenu-text'}>{t('expirations.title')}</span>
                        </Stack>

                    </ButtonBase>
                    <ButtonBase onClick={triggerExpirationsDropDownMenu} sx={{ zIndex: 10 }}>
                        <VectorMenuSVG open={isSubMenuOpen } customStroke={ isSubMenuOpen ? 'white' : palette.secondary[600]} />
                    </ButtonBase>
                </div>

                {isSubMenuOpen &&
                <div>
                    <ButtonBase style={{ padding: '8px 16px 8px 36px', textTransform: 'none', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }}
                        className={groupStyles(selectedTab === EXPIRATIONS_CLOSING_GROUPS[53])} onClick={() => handleSelectTab(EXPIRATIONS_CLOSING_GROUPS[53])} >{t('expirations.table.closingGroups.53')}</ButtonBase>
                    <ButtonBase style={{ padding: '8px 16px 8px 36px', textTransform: 'none', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }}
                        className={groupStyles(selectedTab === EXPIRATIONS_CLOSING_GROUPS[54])} onClick={() => handleSelectTab(EXPIRATIONS_CLOSING_GROUPS[54])}>{t('expirations.table.closingGroups.54')}</ButtonBase>
                    <ButtonBase style={{ padding: '8px 16px 8px 36px', textTransform: 'none', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }}
                        className={groupStyles(selectedTab === EXPIRATIONS_CLOSING_GROUPS[55])} onClick={() => handleSelectTab(EXPIRATIONS_CLOSING_GROUPS[55])}>{t('expirations.table.closingGroups.55')}</ButtonBase>
                    <ButtonBase style={{ padding: '8px 16px 8px 36px', textTransform: 'none', display: 'inline-flex', justifyContent: 'space-between', width: '100%' }}
                        className={groupStyles(selectedTab === EXPIRATIONS_CLOSING_GROUPS[56])} onClick={() => handleSelectTab(EXPIRATIONS_CLOSING_GROUPS[56])}>{t('expirations.table.closingGroups.56')}</ButtonBase>
                </ div>

                }
            </Stack>
        </Box>

    );
}
